import { render } from "./ButtonControl.vue?vue&type=template&id=f4fb2a28&scoped=true"
import script from "./ButtonControl.vue?vue&type=script&lang=js"
export * from "./ButtonControl.vue?vue&type=script&lang=js"

import "./ButtonControl.vue?vue&type=style&index=0&id=f4fb2a28&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f4fb2a28"]])

export default __exports__